export class OrderResponse {
    id: number;
    fboId: String;
    userName: String;
    orderDate: any
    webOrderNumber: string;
    orderNumber: string;
    status: string;
    country: string;
    orderSource: string;
    orderType: string;
    orderTypeId: number;
    totalAmount: number;
    currencyCode?: string;
    cc: number;
    processingMonth: number;
    processingYear: number;
    fullName: string;
    shipToName: string;
    orderGroupId: number;
    memberLevelID: number;
    firstName: string;
    middleName: string;
    lastName: string;
    trackingurl: string;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/order-response.ts